/**
 * @internal
 */
export const white = '#FFFFFF';
/**
 * @internal
 */
export const black = '#000000';
/**
 * @internal
 */
export const accentBaseColor = '#0078D4';
/**
 * @internal
 */
export const neutralBaseColor = '#808080';
